var _path, _circle, _circle2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiSmile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8ZM3.2 8C3.2 10.651 5.34903 12.8 8 12.8C10.651 12.8 12.8 10.651 12.8 8C12.8 5.34903 10.651 3.2 8 3.2C5.34903 3.2 3.2 5.34903 3.2 8Z",
    fill: "#002A69"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.8001,
    cy: 6.7,
    r: 0.7,
    fill: "#002A69"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.2,
    cy: 6.7,
    r: 0.7,
    fill: "#002A69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2814 9.37064C10.6055 9.21994 10.9603 9.46177 10.7716 9.76537C10.6209 10.008 10.3999 10.2285 10.1213 10.4142C9.84274 10.5999 9.51203 10.7472 9.14805 10.8478C8.78407 10.9483 8.39397 11 8 11C7.60603 11 7.21593 10.9483 6.85195 10.8478C6.48797 10.7472 6.15726 10.5999 5.87868 10.4142C5.6001 10.2285 5.37913 10.008 5.22836 9.76537C5.03973 9.46177 5.39451 9.21994 5.71862 9.37064C6.33081 9.65528 7.23095 10 8 10C8.76905 10 9.66919 9.65528 10.2814 9.37064Z",
    fill: "#002A69"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiSmile);
export default __webpack_public_path__ + "static/media/Emoji_smile.16c9e223a0245588249474b2d101604e.svg";
export { ForwardRef as ReactComponent };